import { Dispatch, ExtraArgs, GetState } from '../../../types'
import { isKeyOfMonitoringLocalStorage, MonitoringLocalStorage } from '../../../util/storage/MonitoringLocalStorageManager'
import { getResourceIdFromLS, saveResourceIdInLS } from '../../storage/utils'

export const selectResourceFromResources = <T>(resourceName: string,
                                               resources: T[],
                                               getResourceId: (resource: T) => string,
                                               selectAction: any,
                                               origin?: string,
                                               lsOrigin?: keyof MonitoringLocalStorage,
                                               resourceId?: string,
                                               preferredResourceId?: string) =>
  (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs): T | undefined => {
    const lsResourceId = lsOrigin && isKeyOfMonitoringLocalStorage(lsOrigin) ? getResourceIdFromLS(resourceName, lsOrigin) : undefined
    const maybeResourceId = resourceId || lsResourceId || preferredResourceId
    const maybeResource = resources.find((resource: T) => getResourceId(resource) === maybeResourceId)

    let result = undefined
    if (maybeResource) {
      result = maybeResource
    }

    dispatch(selectAction(result))
    lsOrigin && saveResourceIdInLS(resourceName, lsOrigin, result ? getResourceId(result) : null)

    return result
}
